import {useQuery} from "@apollo/client";
import {FaRegClock} from "react-icons/fa6";

import {LoadingContainer} from "@/components/placeholder/LoadingContainer.tsx";
import {Table} from "@/components/table/Table";
import {GQL_RUM_LIST, RUMListResponse} from "@/lib/queries/rum.ts";
import {CheckStatusIndicator} from "@/pages/checks/list/components/CheckStatusIndicator.tsx";
// @ts-expect-error legacy code
import {checkFeatures} from "@/pages/rum/v2/CheckFeatures.js";
import {RUMBaselineComparison} from "@/pages/rum/v2/list/RUMBaselineComparison.tsx";
import {RUMErrorComparison} from "@/pages/rum/v2/list/RUMErrorComparison.tsx";
import {RUMLink} from "@/pages/rum/v2/list/RUMLink.tsx";
import {RUMListEmpty} from "@/pages/rum/v2/list/RUMListEmpty.tsx";
import {RUMTTIOverTime} from "@/pages/rum/v2/list/RUMTTIOverTime.tsx";

interface RUMListProps {
  pollInterval?: number;
}

export const RUMList = ({pollInterval}: RUMListProps) => {
  const {data, previousData, loading, error} = useQuery<RUMListResponse>(GQL_RUM_LIST, {
    variables: {
      limit: 50,
      offset: 0,
    },
    pollInterval: pollInterval ?? 0,
  });

  if (error) {
    console.error(error);
  }
  const response = loading ? previousData : data;
  if (loading || !response) {
    return <LoadingContainer text="Loading rum checks..." />;
  }

  const {rumServices} = response;
  const {pageViews, pageLoad, ajaxLoad} = checkFeatures;
  if (rumServices?.items.length < 1) {
    return <RUMListEmpty />;
  }

  return (
    <div>
      <div className="row mb-3">
        <div className="col">
          <span className="text-muted fs-7">
            <FaRegClock className="me-1" />
            <span>Showing last 30 minutes (median)</span>
          </span>
        </div>
      </div>
      <Table
        minWidth="800px"
        specs={[
          {
            fieldName: "name",
            fieldTitle: "RUM Check",
            accessor: (row) => <RUMLink id={row.id} name={row.name} address={row.msp_address} />,
          },
          {
            fieldName: "pageviews",
            fieldTitle: "Page Views",
            accessor: (row) => <RUMBaselineComparison feature={pageViews} rowData={row.rowData} />,
          },
          {
            fieldName: "tti",
            fieldTitle: "TTI",
            accessor: (row) => <RUMBaselineComparison feature={pageLoad} rowData={row.rowData} />,
          },
          {
            fieldName: "ajax",
            fieldTitle: "AJAX",
            accessor: (row) => <RUMBaselineComparison feature={ajaxLoad} rowData={row.rowData} />,
          },
          {
            fieldName: "error_rate",
            fieldTitle: "Error Rate",
            accessor: (row) => <RUMErrorComparison rowData={row.rowData} />,
          },
          {
            fieldName: "tti_over_time",
            fieldTitle: "TTI Over Time",
            accessor: (row) => <RUMTTIOverTime rowData={row.rowData} graphData={row.graphData} />,
          },
        ]}
        rows={rumServices.items}
        indicatorColumnSpec={{
          fieldName: "indicator",
          accessor: (obj) => <CheckStatusIndicator service={obj} />,
          meta: {columnClassName: "indicator p-0"},
        }}
      />
    </div>
  );
};
